import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Stack,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  useTheme,
} from "@mui/material";

const TableTheme = ({ data, handleRowClick, getInfoThemeActif,role }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const isOnet = role === "onet";
  const isCompass = role === "compass"
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeItemsPerPage = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1); // Reset to first page when changing number of items per page
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 2,borderTopLeftRadius: 0, overflow: 'hidden', boxShadow:2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nom</TableCell>
            <TableCell align="right">Site</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentItems.map((item, indexThemes) => (
            <TableRow
              key={indexThemes}
              sx={{
                backgroundColor: indexThemes % 2 === 0
                  ? theme.palette.background.alternate
                  : theme.palette.background.paper,
                '&:hover': {
                  backgroundColor: isDark
                    ? 'rgba(255, 255, 255, 0.1)'
                    : 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              {item.themes.map((el, index) => (
                <React.Fragment key={index}>
                  <TableCell>
                    <span
                      onClick={() => handleRowClick(indexThemes + indexOfFirstItem)}
                      style={{ cursor: "pointer", fontWeight: "bold" }}
                    >
                      {el.name}
                    </span>
                  </TableCell>
                  <TableCell align="right">{el.sites.length}</TableCell>
                </React.Fragment>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
        padding={2}
      >
        <FormControl variant="outlined" size="small">
          <InputLabel  sx={{
                              color: isDark ? theme.palette.text.primary : 'black',
                              '&.Mui-focused': {
                                color: isDark ? theme.palette.text.primary : 'black',
                              },
                            }} id="items-per-page-label">Thèmes</InputLabel>
          <Select
            labelId="items-per-page-label"
            value={itemsPerPage}
            label="Plugins"
            onChange={handleChangeItemsPerPage}
            sx={{
              borderRadius: 2,
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: isOnet
                  ? '#06305C'
                  : isCompass
                    ? '#c4ac66'
                    : isDark
                      ? 'rgba(255, 255, 255, 0.23)'
                      : '#F7E900',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: isOnet ? '#06305C' : isCompass ? '#c4ac66' : '#F7E900',
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  '& .MuiMenuItem-root:hover': {
                    backgroundColor: isOnet
                      ? 'rgba(6, 48, 92, 0.08)'
                      : isCompass
                        ? 'rgba(196, 172, 102, 0.08)'
                        : isDark
                          ? 'rgba(255, 255, 255, 0.08)'
                          : 'rgba(247, 233, 0, 0.08)',
                  },
                  '& .MuiMenuItem-root.Mui-selected': {
                    backgroundColor: isOnet
                      ? 'rgba(6, 48, 92, 0.12)'
                      : isCompass
                        ? 'rgba(196, 172, 102, 0.12)'
                        : isDark
                          ? 'rgba(255, 255, 255, 0.08)'
                          : 'rgba(247, 233, 0, 0.12)',
                  },
                  '& .MuiMenuItem-root.Mui-selected:hover': {
                    backgroundColor: isOnet
                      ? 'rgba(6, 48, 92, 0.16)'
                      : isCompass
                        ? 'rgba(196, 172, 102, 0.16)'
                        : isDark
                          ? 'rgba(255, 255, 255, 0.12)'
                          : 'rgba(247, 233, 0, 0.16)',
                  },
                },
              },
            }}
          >
            <MenuItem  value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          count={Math.ceil(data.length / itemsPerPage)}
          page={currentPage}
          onChange={handleChangePage}
          variant="outlined"
          sx={{
            "& .MuiPaginationItem-root": {
              backgroundColor: isOnet
                ? (isDark ? theme.palette.background.paper : '')
                : (isDark ? theme.palette.background.paper : "white"),
              color: isDark ? theme.palette.text.primary : "black",
              "&.Mui-selected": {
                backgroundColor: isOnet ? '#06305C' : isCompass ? '#c4ac66' : "rgba(247, 233, 0, 0.4)",
                border: isOnet
                  ? "1px solid"
                  : `1px solid ${isDark ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)'}`,
                color: isOnet ? "white" : isCompass ? "white" : (isDark ? "white" : "black"),
              },
              "&:hover": {
                backgroundColor: isOnet
                  ? '#06305C'
                  : isCompass
                    ? '#c4ac66'
                    : (isDark ? "rgba(247, 233, 0, 0.2)" : "rgba(247, 233, 0, 0.4)"),
                color: isOnet
                  ? "white"
                  : isCompass
                    ? "white"
                    : (isDark ? "white" : "rgba(0, 0, 0, 0.23)"),
                border: isOnet
                  ? "1px solid"
                  : `1px solid ${isDark ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)'}`,
              },
            }
          }}
        />
      </Stack>
    </TableContainer>
  );
};

export default TableTheme;
